import { RuntimeConfig } from "nuxt/schema";
import { ProductReviewPreviewType } from "~/types/shop/review/ProductReviewPreviewType";
import { ProductPreviewForReviewEntity } from "~/entities/shop/ProductPreviewForReviewEntity";

export const ProductReviewPreviewEntity = function (data: any, config: RuntimeConfig): ProductReviewPreviewType {
    return {
        title: data?.attributes?.title,
        text: data?.attributes?.preview_text,
        slug: data?.attributes?.slug,
        products: data?.attributes?.products?.map(item => ProductPreviewForReviewEntity(item, config)),
        url: `/reviews/review-${data?.attributes?.slug}`,
    };
};